import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_NETWORK: GlameraIconDefinition = {
  name: 'network',
  viewBox: '0 0 24 24',
  svg: `
    <rect class="glm-network-node glm-network-node-br" x="16" y="16" width="6" height="6" rx="1"></rect>
    <rect class="glm-network-node glm-network-node-bl" x="2" y="16" width="6" height="6" rx="1"></rect>
    <rect class="glm-network-node glm-network-node-top" x="9" y="2" width="6" height="6" rx="1"></rect>
    <path class="glm-network-branch" d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"></path>
    <path class="glm-network-stem" d="M12 12V8"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-network-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './network.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class NetworkIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_NETWORK;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
